export default "__VITE_ASSET__B2i5pfT2__"